import { resolveWindow } from "../SingleAlternative";

const rearangeThreshold = (stepsArray, startCalDay) => {
  let startOfYear = stepsArray.filter(el => el.julian < startCalDay);
  let endOfYear = stepsArray.filter(el => el.julian >= startCalDay);
  let merged = [...endOfYear, ...startOfYear];
  return merged.map(el => {
    let month = `${el.monthNum}`;
    let day = `${el.day}`;

    if(month.length === 1) month = "0" + month;
    if(day.length === 1) day = "0" + day;

    return {
      ...el,
      calDate: `${month}-${day}`
    }
  });
};

export const countAbove = (scenario, threshold, multiplier=1, startCalDay, ALL_DAYS) => {
  // return 1;

  try {
    let { startWindow, endWindow, isWindow, isStepped, steps=[], stepsLower=[], isRange, value, upperRange, lowerRange } = threshold;

    if(!isWindow && !isStepped && !isRange){

      // add check for range here....
      let compValue = parseFloat(threshold.value);
      let traceValues = scenario.y;

      let count = 0;
      
      traceValues.forEach(val => {
        if(isNaN(parseFloat(val))) return;
        if(parseFloat(val) > compValue) count += 1;
      })

      return count;
    }

    if(!isWindow && !isStepped && isRange){

      // add check for range here....
      let compValue = parseFloat(threshold.upperRange);
      let traceValues = scenario.y;

      let count = 0;
      
      traceValues.forEach(val => {
        if(isNaN(parseFloat(val))) return;
        if(parseFloat(val) > compValue) count += 1;
      })

      return count;
    }

    // basic threshold with window
    if(isWindow && !isStepped && !isRange){

      let indexOfStartCal = ALL_DAYS.findIndex((day) => day.julian === startWindow);
      let indexOfEndCal = ALL_DAYS.findIndex((day) => day.julian === endWindow);

      // add check for range here....
      let compValue = parseFloat(threshold.value);
      let traceValues = scenario.y.slice(indexOfStartCal, indexOfEndCal + 1);

      let count = 0;
      
      traceValues.forEach(val => {
        if(isNaN(parseFloat(val))) return;
        if(parseFloat(val) > compValue) count += 1;
      });

      return count;
    }

    // basic threshold with range window
    if(isWindow && !isStepped && isRange){

      let startDayIndex = ALL_DAYS.findIndex(el => el.julian === startWindow);
      let endDayIndex = ALL_DAYS.findIndex(el => el.julian === endWindow);

      if(endDayIndex === -1) endDayIndex = ALL_DAYS.length;
      if(startDayIndex === -1) startDayIndex = 0;

      let ySliced = scenario.y.slice(startDayIndex, endDayIndex + 1);

      // add check for range here....
      let compValue = parseFloat(threshold.lowerRange);

      let count = 0;
      
      ySliced.forEach(val => {
        if(isNaN(parseFloat(val))) return;
        if(parseFloat(val) > compValue) count += 1;
      });

      return count;
    }

    // single stepped year-round
    if(isStepped && !isWindow && !isRange){

      let counter = 0;

      steps.forEach((step, index) => {
        let stepValue = parseFloat(step.value);
        let traceValue = parseFloat(scenario?.y[index]);
        // console.log({date: step.date, stepValue, traceValue});
        if(isNaN(stepValue) || isNaN(traceValue)) return;
        if(stepValue < traceValue) counter += 1;
      });

      return counter;
    }

    // stepped range, not window
    if(isStepped && !isWindow && isRange){

      let counter = 0;

      stepsLower.forEach((step, index) => {
        let stepValue = parseFloat(step.value);
        let traceValue = parseFloat(scenario?.y[index]);
        // console.log({date: step.date, stepValue, traceValue});
        if(isNaN(stepValue) || isNaN(traceValue)) return;
        if(stepValue < traceValue) counter += 1;
      });

      return counter;
    }

    if(isStepped && isWindow && !isRange){

      let counter = 0;

      const filteredSteps = steps.filter(el => ALL_DAYS.find(day => day.julian === el.julian));

      filteredSteps.forEach((stepVal, index) => {
        let stepValue = parseFloat(stepVal.value);
        let traceValue = parseFloat(scenario.y[index]);
        if(isNaN(stepValue) || isNaN(traceValue)) return;
        if(stepValue < traceValue) counter += 1;
      });

      return counter;
    }

    if(isStepped && isWindow && isRange){


      let counter = 0;

      const filteredSteps = stepsLower.filter(el => ALL_DAYS.find(day => day.julian === el.julian));
      const filteredY = scenario.y.filter((el, i) => ALL_DAYS.find(d => d.date === scenario.x[i]));

      filteredSteps.forEach((stepVal, index) => {
        let stepValue = parseFloat(stepVal.value);
        let traceValue = parseFloat(filteredY[index]);
        if(isNaN(stepValue) || isNaN(traceValue)) return;
        if(stepValue < traceValue) counter += 1;
      });

      return counter;
    }
    // let window = [];
    // if(!threshold.isStepped){
    //   if(threshold.isWindow){
    //     window = resolveWindow(ALL_DAYS, threshold);
    //   }
    //   let count = scenario.y.reduce((a, b, index) => {
    //     // if this date is not in the thresholds window, ignore it;
    //     if(threshold.isWindow && !window.map(el => el.calDate).includes(scenario.x[index])) return a;

    //     let compVal = parseFloat(threshold.value);
        
    //     if(threshold.isRange) compVal = parseFloat(threshold.upperRange);

    //     if(isNaN(compVal) || isNaN(parseFloat(b))) return a;

    //     if(b > compVal){
    //       return a += 1;
    //     } else {
    //       return a;
    //     }

    //   }, 0);
    //   return count * multiplier
    // } else {
    //   let steps = rearangeThreshold(threshold.steps, startCalDay);
    //   let filtered = steps.filter(({calDate}) => scenario.x.some(day => day.includes(calDate)));
    //   let count = scenario.y.reduce((a, b, index) => {
    //   let compVal = parseFloat(filtered[index]?.value);
    //   if(isNaN(compVal) || isNaN(parseFloat(b))) return a;
    //     if(b > compVal){
    //       return a += 1;
    //     } else {
    //       return a;
    //     }
    //   }, 0);
    //   return count * multiplier;
    // }
  } catch (err){
    console.log(err);
    return "Error";
  }
};

export const countEqual = (scenario, threshold, multiplier=1, startCalDay, ALL_DAYS) => {

  try {
    let { startWindow, endWindow, isWindow, isStepped, steps=[], stepsLower=[], isRange, value, upperRange, lowerRange } = threshold;

    if(!isWindow && !isStepped && !isRange){

      // add check for range here....
      let compValue = parseFloat(threshold.value);
      let traceValues = scenario.y;

      let count = 0;
      
      traceValues.forEach(val => {
        if(isNaN(parseFloat(val))) return;
        if(parseFloat(val) === compValue) count += 1;
      })

      return count;
    }

    // basic threshold with window
    if(isWindow && !isStepped && !isRange){

      let indexOfStartCal = ALL_DAYS.findIndex((day) => day.julian === startWindow);
      let indexOfEndCal = ALL_DAYS.findIndex((day) => day.julian === endWindow);

      // add check for range here....
      let compValue = parseFloat(threshold.value);
      let traceValues = scenario.y.slice(indexOfStartCal, indexOfEndCal + 1);

      let count = 0;
      
      traceValues.forEach(val => {
        if(isNaN(parseFloat(val))) return;
        if(parseFloat(val) === compValue) count += 1;
      });

      return count;
    }

    // basic threshold with range window
    if(isWindow && !isStepped && isRange){

      let startDayIndex = ALL_DAYS.findIndex(el => el.julian === startWindow);
      let endDayIndex = ALL_DAYS.findIndex(el => el.julian === endWindow);

      if(endDayIndex === -1) endDayIndex = ALL_DAYS.length;
      if(startDayIndex === -1) startDayIndex = 0;

      let ySliced = scenario.y.slice(startDayIndex, endDayIndex + 1);

      // add check for range here....
      let compValue = parseFloat(threshold.lowerRange);

      let count = 0;
      
      ySliced.forEach(val => {
        if(isNaN(parseFloat(val))) return;
        if(parseFloat(val) === compValue) count += 1;
      });

      return count;
    }

    // single stepped year-round
    if(isStepped && !isWindow && !isRange){

      let counter = 0;

      steps.forEach((step, index) => {
        let stepValue = parseFloat(step.value);
        let traceValue = parseFloat(scenario?.y[index]);
        // console.log({date: step.date, stepValue, traceValue});
        if(isNaN(stepValue) || isNaN(traceValue)) return;
        if(stepValue === traceValue) counter += 1;
      });

      return counter;
    }

    // stepped range, not window
    if(isStepped && !isWindow && isRange){

      let counter = 0;

      stepsLower.forEach((step, index) => {
        let stepValue = parseFloat(step.value);
        let traceValue = parseFloat(scenario?.y[index]);
        // console.log({date: step.date, stepValue, traceValue});
        if(isNaN(stepValue) || isNaN(traceValue)) return;
        if(stepValue === traceValue) counter += 1;
      });

      return counter;
    }

    if(isStepped && isWindow && !isRange){

      let counter = 0;

      const filteredSteps = steps.filter(el => ALL_DAYS.find(day => day.julian === el.julian));

      filteredSteps.forEach((stepVal, index) => {
        let stepValue = parseFloat(stepVal.value);
        let traceValue = parseFloat(scenario.y[index]);
        if(isNaN(stepValue) || isNaN(traceValue)) return;
        if(stepValue === traceValue) counter += 1;
      });

      return counter;
    }

    if(isStepped && isWindow && isRange){


      let counter = 0;

      const filteredSteps = stepsLower.filter(el => ALL_DAYS.find(day => day.julian === el.julian));
      const filteredY = scenario.y.filter((el, i) => ALL_DAYS.find(d => d.date === scenario.x[i]));

      filteredSteps.forEach((stepVal, index) => {
        let stepValue = parseFloat(stepVal.value);
        let traceValue = parseFloat(filteredY[index]);
        if(isNaN(stepValue) || isNaN(traceValue)) return;
        if(stepValue === traceValue) counter += 1;
      });

      return counter;
    }
  } catch (err) {
    console.log(err);
    return "Error";
  }

  // console.log({ALL_DAYS, scenario, threshold: threshold.data});
  // return 1;
  // try {
  //   if(!threshold.isStepped){
  //     let window = [];
  //     if(threshold.isWindow){
  //       window = resolveWindow(ALL_DAYS, threshold);
  //     }
  //     let count = scenario.y.reduce((a, b, index) => {
  //       if(threshold.isWindow && !window.map(el => el.calDate).includes(scenario.x[index])) return a;
  //       let compVal = parseFloat(threshold.value);
  //       if(isNaN(parseFloat(b)) || isNaN(compVal)) return a;
  //       if(b === compVal){
  //         return a += 1;
  //       } else {
  //         return a;
  //       }
  //     }, 0);
  //     return count * multiplier
  //   } else {
  //     // return 1;
  //     let filtered = rearangeThreshold(threshold.steps, startCalDay)
  //     .filter(({calDate}) => scenario.x.some(day => day.includes(calDate)));
  //     let count = scenario.y.reduce((a, b, index) => {
  //       let compVal = parseFloat(filtered[index].value);
  //       if(isNaN(parseFloat(b)) || isNaN(compVal)) return a;
  //       if(b === compVal){
  //         return a += 1;
  //       } else {
  //         return a;
  //       }
  //     }, 0);
  //     return count * multiplier;
  //   }
  // } catch(err){
  //   console.log(err);
  //   return 'Error';
  // };
};

// given a trace (scenario), count how many times the trace falls below the threshold value for a given day.
export const countBelow = (scenario, threshold, multiplier=1, startCalDay, ALL_DAYS) => {

  try {
    let { startWindow, endWindow, isWindow, isStepped, steps=[], stepsLower=[], isRange, value, upperRange, lowerRange } = threshold;

    if(!isWindow && !isStepped && !isRange){

      // add check for range here....
      let compValue = parseFloat(threshold.value);
      let traceValues = scenario.y;

      let count = 0;
      
      traceValues.forEach(val => {
        if(isNaN(parseFloat(val))) return;
        if(parseFloat(val) < compValue) count += 1;
      })

      return count;
    }

    if(!isWindow && !isStepped && isRange){

      // add check for range here....
      let compValue = parseFloat(threshold.lowerRange);
      let traceValues = scenario.y;

      let count = 0;
      
      traceValues.forEach(val => {
        if(isNaN(parseFloat(val))) return;
        if(parseFloat(val) < compValue) count += 1;
      })

      return count;
    }

    // basic threshold with window
    if(isWindow && !isStepped && !isRange){

      let indexOfStartCal = ALL_DAYS.findIndex((day) => day.julian === startWindow);
      let indexOfEndCal = ALL_DAYS.findIndex((day) => day.julian === endWindow);

      // add check for range here....
      let compValue = parseFloat(threshold.value);
      let traceValues = scenario.y.slice(indexOfStartCal, indexOfEndCal + 1);

      let count = 0;
      
      traceValues.forEach(val => {
        if(isNaN(parseFloat(val))) return;
        if(parseFloat(val) < compValue) count += 1;
      });

      return count;
    }

    // basic threshold with range window
    if(isWindow && !isStepped && isRange){

      let startDayIndex = ALL_DAYS.findIndex(el => el.julian === startWindow);
      let endDayIndex = ALL_DAYS.findIndex(el => el.julian === endWindow);

      if(endDayIndex === -1) endDayIndex = ALL_DAYS.length;
      if(startDayIndex === -1) startDayIndex = 0;

      let ySliced = scenario.y.slice(startDayIndex, endDayIndex + 1);

      // add check for range here....
      let compValue = parseFloat(threshold.lowerRange);

      let count = 0;
      
      ySliced.forEach(val => {
        if(isNaN(parseFloat(val))) return;
        if(parseFloat(val) < compValue) count += 1;
      });

      return count;
    }

    // single stepped year-round
    if(isStepped && !isWindow && !isRange){

      let counter = 0;

      steps.forEach((step, index) => {
        let stepValue = parseFloat(step.value);
        let traceValue = parseFloat(scenario?.y[index]);
        // console.log({date: step.date, stepValue, traceValue});
        if(isNaN(stepValue) || isNaN(traceValue)) return;
        if(stepValue > traceValue) counter += 1;
      });

      return counter;
    }

    // stepped range, not window
    if(isStepped && !isWindow && isRange){

      let counter = 0;

      stepsLower.forEach((step, index) => {
        let stepValue = parseFloat(step.value);
        let traceValue = parseFloat(scenario?.y[index]);
        // console.log({date: step.date, stepValue, traceValue});
        if(isNaN(stepValue) || isNaN(traceValue)) return;
        if(stepValue > traceValue) counter += 1;
      });

      return counter;
    }

    if(isStepped && isWindow && !isRange){

      let counter = 0;

      const filteredSteps = steps.filter(el => ALL_DAYS.find(day => day.julian === el.julian));

      filteredSteps.forEach((stepVal, index) => {
        let stepValue = parseFloat(stepVal.value);
        let traceValue = parseFloat(scenario.y[index]);
        if(isNaN(stepValue) || isNaN(traceValue)) return;
        if(stepValue > traceValue) counter += 1;
      });

      return counter;
    }

    if(isStepped && isWindow && isRange){


      let counter = 0;

      const filteredSteps = stepsLower.filter(el => ALL_DAYS.find(day => day.julian === el.julian));
      const filteredY = scenario.y.filter((el, i) => ALL_DAYS.find(d => d.date === scenario.x[i]));

      filteredSteps.forEach((stepVal, index) => {
        let stepValue = parseFloat(stepVal.value);
        let traceValue = parseFloat(filteredY[index]);
        if(isNaN(stepValue) || isNaN(traceValue)) return;
        if(stepValue > traceValue) counter += 1;
      });

      return counter;
    }
  } catch (err) {
    console.log(err);
    return "Error";
  }
};

export const countBetween = (scenario, threshold, multiplier=1, startCalDay, ALL_DAYS) => {
  // return 1;
  try {
    let window = [];
    if(threshold.isRange){
      if(threshold.isStepped){
        let upperRange = rearangeThreshold(threshold.steps, startCalDay);
        let lowerRange = rearangeThreshold(threshold.stepsLower, startCalDay);
        let filteredUpper = upperRange.filter(({date}) => scenario.x.includes(date));
        let filteredLower = lowerRange.filter(({date}) => scenario.x.includes(date));
        let count = scenario.y.reduce((a, b, index) => {
          let compValUpper = parseFloat(filteredUpper[index].value);
          let compValLower = parseFloat(filteredLower[index].value);
          if(b <= compValUpper && b >= compValLower){
            return a+=1;
          } else {
            return a;
          }
        }, 0);
        return count * multiplier;
      } else {
        if(threshold.isWindow){
          window = resolveWindow(ALL_DAYS, threshold);
        }
        let count = scenario.y.reduce((a, b, index) => {
          if(threshold.isWindow && !window.map(el => el.calDate).includes(scenario.x[index])) return a;
          if(isNaN(parseFloat(b))) return a;
          if(b <= parseFloat(threshold.upperRange) && b >= parseFloat(threshold.lowerRange)){
            return a+=1;
          } else {
            return a;
          }
        }, 0);
        return multiplier * count;
      }
    } else {
      let count = scenario.y.reduce((a, b) => {
        if(isNaN(parseFloat(b))) return a;
        if(b <= threshold.upperRange && b >= threshold.lowerRange){
          return a+=1;
        } else {
          return a;
        }
      }, 0);
      return count * multiplier;
    }
  } catch (err) {
    console.log(err);
    return "Error";
  }
  
};


export const accumulatePriorDays = (data, nDays, method) => {
  if (!Array.isArray(data)) throw new Error("data must be an array");
  if (!Number.isFinite(nDays) || nDays < 1) throw new Error("nDays must be a positive integer");
  const m = String(method || '').toLowerCase();
  const isAvg = m === 'average' || m === 'avg' || m === 'mean';
  const isSum = m === 'sum';
  const isMin = m === 'min';
  const isMax = m === 'max';
  if (!(isAvg || isSum || isMin || isMax)) {
    throw new Error("method must be one of: sum, average, avg, mean, min, max");
  }

  const DAY = 24 * 60 * 60 * 1000;

  // Parse dates once and remember original indices
  const n = data.length;
  const dates = new Array(n);
  for (let i = 0; i < n; i++) {
    // Parse as UTC midnight to avoid timezone drift
    dates[i] = Date.parse(data[i].date + "T00:00:00Z");
    if (!Number.isFinite(dates[i])) throw new Error(`Invalid date at index ${i}: ${data[i].date}`);
  }

  const order = Array.from({ length: n }, (_, i) => i).sort((a, b) => dates[a] - dates[b]);

  // Sliding window state (stores indices of prior items)
  let q = [];        // queue of indices in window (chronological)
  let qHead = 0;     // head pointer so we don't shift() (O(1))
  let runningSum = 0;
  let runningCount = 0;

  // Monotonic deques for min/max (store indices)
  let minD = [];
  let maxD = [];

  const out = new Array(n);

  // Helpers to remove an index j (must be the current head of q)
  function pruneOldAndSameDay(currentIdx) {
    const di = dates[currentIdx];

    // 1) Eject anything older than nDays
    while (qHead < q.length && (di - dates[q[qHead]]) > nDays * DAY) {
      const j = q[qHead++];
      // update sum/count
      runningSum -= data[j].value;
      runningCount--;

      // fix min/max fronts if they reference j
      if (minD.length && minD[0] === j) minD.shift();
      if (maxD.length && maxD[0] === j) maxD.shift();
    }

    // 2) Eject any same-day entries (strictly "prior day(s)" only)
    while (qHead < q.length && dates[q[qHead]] === di) {
      const j = q[qHead++];
      runningSum -= data[j].value;
      runningCount--;
      if (minD.length && minD[0] === j) minD.shift();
      if (maxD.length && maxD[0] === j) maxD.shift();
    }
  }

  function addToWindow(j) {
    // push to queue
    q.push(j);
    runningSum += data[j].value;
    runningCount++;

    // maintain monotonic min deque (increasing values)
    while (minD.length && data[minD[minD.length - 1]].value >= data[j].value) {
      minD.pop();
    }
    minD.push(j);

    // maintain monotonic max deque (decreasing values)
    while (maxD.length && data[maxD[maxD.length - 1]].value <= data[j].value) {
      maxD.pop();
    }
    maxD.push(j);
  }

  // Iterate chronologically; for each i:
  //  - prune window to keep only indices j with 1..nDays before i's date
  //  - compute accumulatedValue from current window
  //  - add i to window (so it's available for future items)
  for (let k = 0; k < n; k++) {
    const i = order[k];
    pruneOldAndSameDay(i);

    let acc = null;
    if (runningCount > 0) {
      if (isSum) acc = runningSum;
      else if (isAvg) acc = runningSum / runningCount;
      else if (isMin) acc = data[minD[0]].value;
      else if (isMax) acc = data[maxD[0]].value;
    }

    out[i] = { ...data[i], accumulatedValue: acc };

    // Add current index i AFTER computing (so it's not included in its own look-back)
    addToWindow(i);
  }

  return out;
};


export const applyWindowValue = (days, windows, opts = {}) => {
  
  const { valueKey = "value", outsideValue = null } = opts;

  const winArray = Array.isArray(windows) ? windows : [windows];

  const inWindow = (j, start, end) => {
    // Inclusive window; handle wrap-around (e.g., start=350, end=20)
    if (start <= end) return j >= start && j <= end;
    return j >= start || j <= end;
  };

  return days.map(d => {
    const j = d.julian;
    // Sum values of all windows that include this julian day
    const total = winArray.reduce((acc, w) => {
      if (!w || typeof w.startWindow !== "number" || typeof w.endWindow !== "number") return acc;
      return inWindow(j, w.startWindow, w.endWindow) ? acc + (Number(w[valueKey]) || 0) : acc;
    }, 0);

    return { ...d, [valueKey]: total === 0 ? outsideValue : total };
  });
}

